import { useLocation, useNavigate } from 'react-router-dom'
import { LogOut } from 'lucide-react'
import { useAuth } from '@/hooks/useAuth'
import { useCompany } from '@/hooks/useCompany'
import { NAV_ITEMS } from './Sidebar'

export function Header() {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { signOut } = useAuth()
  const company = useCompany()

  const active = NAV_ITEMS.find(n =>
    n.path === '/' ? pathname === '/' : pathname.startsWith(n.path)
  ) ?? NAV_ITEMS[0]

  const handleSignOut = async () => {
    try { await signOut() } catch {}
    navigate('/login')
  }

  // Mobile-only: sidebar handles desktop nav
  return (
    <header className="md:hidden flex items-center justify-between gap-4 px-4 py-3 border-b border-white/8 bg-gray-950">
      <div className="flex items-center gap-3 min-w-0">
        <img
          src={company.logoUrl ?? '/LogoNibpr.png'}
          alt={company.shortName}
          className="h-8 w-8 shrink-0 rounded object-contain"
        />
        <h1 className="text-base font-bold text-white truncate">{active.label}</h1>
      </div>
      <button
        onClick={handleSignOut}
        className="shrink-0 p-2 rounded-lg text-white/40 hover:text-red-400 hover:bg-red-500/10 transition-colors"
        aria-label="Cerrar sesión"
      >
        <LogOut className="h-4 w-4" />
      </button>
    </header>
  )
}
